import { Component, HostListener, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { BandejaInscripcionesComponent } from '../listado-inscripciones/bandeja-inscripciones/bandeja-inscripciones.component';
import { Solicitud } from '../../../../../interfaces/interface-bakend/ofertas-laborales/solicitudes.interface';
import {
    APP_CONFIG_OFERTAS,
    IAppOfertas,
} from '../../../../../app.config/app.config-ofertas';
import { SolicitudesService } from '../../../../../services/ofertas-laborales/solicitudes.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { SignoSede } from 'src/app/interfaces/interface-bakend/entidades/signo-sede.interface';
import { SignoSedeService } from 'src/app/services/entidades/signo-sedes.service';
import { Actividad } from '@interfaces/interface-bakend/ofertas-laborales/actividad.interface';
import { ActividadesService } from '@services/ofertas-laborales/actividades.service';
import * as XLSX from 'xlsx';

@Component({
    selector: 'app-listado-inscripciones',
    templateUrl: './listado-inscripciones.component.html',
    styleUrls: ['./listado-inscripciones.component.scss'],
})
export class ListadoInscripcionesComponent implements OnInit, OnDestroy {
    solicitudes: Solicitud[] = [];
    flagLoaded = true;
    activarButton = true;
    fecha: any;

    // Lista visible (tabla custom)
    solicitudesVisibles: any[] = [];
    solicitudesFiltradas: any[] = [];
    solicitudesPaginadas: any[] = [];
    totalPaginas = 1;
    textoFiltro = '';
    paginaActual = 1;
    pageSize = 10;
    pageSizeOptions: number[] = [5, 10, 25, 100];
    skeletonRows: number[] = [1, 2, 3, 4, 5, 6];

    // Dropdowns de filtros (Sede / Estado)
    dropdownAbierto: 'sede' | 'estado' | null = null;
    dropdownPos = { top: 0, left: 0 };

    // Tooltip custom
    tooltipVisible = false;
    tooltipTexto = '';
    tooltipPos = { top: 0, left: 0 };
    tooltipTimeout: any = null;

    estadosChips: { number: number; name: string; detail?: string }[] = [];
    selectedEstados: number[] = [];
    sedesByUsuario: SignoSede[] = [];
    selectSede: string[] = [];
    actividades: Actividad[] = [];
    idActividadSeleccionada: string;
    /** Id centinela del trámite sintético "Todos" (no es una actividad real). */
    readonly TODOS_ID = '__TODOS__';
    /** Orden por fecha de la tabla (click en el header Fecha). */
    ordenFecha: 'asc' | 'desc' = 'desc';
    flagSolicitudesCargadas = false;
    flagCargandoTramites = true;

    solicitudCounts: {
        pendientes: { [key: string]: number };
        leidas: { [key: string]: number };
    } = {
        pendientes: {},
        leidas: {},
    };

    fechaDesde: Date;
    fechaHasta: Date;
    fechaDesdeStr = '';
    fechaHastaStr = '';

    cantidadSolicitudesPendientes = 0;
    cantidadSolicitudesLeidas = 0;
    cantidadSolicitudesTotal = 0;

    loading = false;

    private newStateSubscription: Subscription;

    // IDs de las tres actividades de inscripción
    private readonly idsInscripciones = [
        '68c9c64799bb6b0adb6715c8',
        '68c9c61e99bb6b0adb671593',
        '68c86b61e6c4fc16024be451',
    ];

    private readonly FECHA_CORTE_FILTRO = new Date('2026-08-04T00:00:00.000Z');

    constructor(
        @Inject(APP_CONFIG_OFERTAS) public iAppOfertas: IAppOfertas,
        private router: Router,
        private solicitudesService: SolicitudesService,
        public dialog: MatDialog,
        private authService: AuthService,
        private signoSedeService: SignoSedeService,
        private actividadesService: ActividadesService,
        private snackBar: MatSnackBar
    ) {
        // Estados de la bandeja: parcial, con DDJJ, aprobada y anulada.
        const ordenEstados = [14, 15, 16, 5];
        this.estadosChips = ordenEstados
            .map((n) =>
                this.iAppOfertas.selectEstados.find((e) => e.number === n)
            )
            .filter((e) => !!e) as { number: number; name: string; detail?: string }[];

        this.newStateSubscription = this.solicitudesService
            .getsetNewStater()
            .subscribe((resp) => {
                const idx = this.solicitudesVisibles.findIndex(
                    (s) => s._id === resp?.state?._id
                );
                if (idx !== -1) {
                    this.solicitudesVisibles[idx].lastState_numberState =
                        resp.state?.lastState?.numberState;
                    this.recalcularLista();
                }
            });
    }

    establecerFechadeBusqueda(): void {
        const ahora = new Date();
        this.fechaDesde = new Date(ahora.getFullYear(), ahora.getMonth(), 1);
        this.fechaHasta = new Date(
            ahora.getFullYear(),
            ahora.getMonth() + 1,
            0
        );
        this.fechaDesdeStr = this.formatDate(this.fechaDesde);
        this.fechaHastaStr = this.formatDate(this.fechaHasta);
    }

    async ngOnInit(): Promise<void> {
        this.selectedEstados = this.estadosChips.map((e) => e.number);
        this.establecerFechadeBusqueda();
        await this.obtenerSedesUsuario();
        await this.getActividadesInscripcion();
    }

    ngOnDestroy(): void {
        if (this.newStateSubscription) {
            this.newStateSubscription.unsubscribe();
        }
    }

    formatDate(date: Date): string {
        return date.toISOString().split('T')[0];
    }

    // Carga únicamente las tres actividades de inscripción
    async getActividadesInscripcion(): Promise<void> {
        this.flagCargandoTramites = true;
        try {
            const actividadesPromises = this.idsInscripciones.map((id) =>
                this.actividadesService.getActividadesFindOne(id)
            );
            this.actividades = await Promise.all(actividadesPromises);
            // Por defecto arranca en "Todos".
            this.idActividadSeleccionada = this.TODOS_ID;
        } catch (error) {
            console.error('Error al cargar actividades de inscripción:', error);
            this.snackBar.open('Error al cargar actividades de inscripción', 'Cerrar', {
                duration: 3000,
            });
        } finally {
            this.flagCargandoTramites = false;
        }
    }

    async obtenerSedesUsuario(): Promise<void> {
        const sedes = await this.signoSedeService.getSedes();
        const usuario = await this.authService.getUserLogon();
        if (sedes) {
            this.sedesByUsuario = sedes.filter((sede: any) =>
                usuario.signoSedes.includes(sede?._id)
            );
            this.checkSedes();
        }
    }

    checkSedes(): void {
        this.selectSede = this.sedesByUsuario.map((sede) => sede._id);
    }

    // Búsqueda principal por fechas
    async buscarPorFechas(): Promise<void> {
        this.cantidadSolicitudesLeidas = 0;
        this.cantidadSolicitudesPendientes = 0;
        this.cantidadSolicitudesTotal = 0;

        if (this.fechaDesdeStr && this.fechaHastaStr) {
            this.flagLoaded = false;
            this.fecha = {
                fechaDesde: this.fechaDesdeStr,
                fechaHasta: this.fechaHastaStr,
            };
            this.flagSolicitudesCargadas = false;

            if (this.selectSede.length === 0 || this.selectedEstados.length === 0) {
                this.solicitudesVisibles = [];
                this.solicitudesFiltradas = [];
                this.solicitudesPaginadas = [];
                this.totalPaginas = 1;
                this.paginaActual = 1;
                this.flagLoaded = true;
                return;
            }

            const sedesParams = { signoSedes: this.selectSede };
            try {
                await this.cargarInicialdeSolicitudes(sedesParams, this.fecha);
            } finally {
                this.flagLoaded = true;
            }
        } else {
            this.snackBar.open('Por favor, seleccione ambas fechas', 'Cerrar', {
                duration: 3000,
            });
        }
    }

    async seleccionarActividad(actividad: Actividad): Promise<void> {
        if (this.flagSolicitudesCargadas) {
            this.flagLoaded = false;
            this.idActividadSeleccionada = actividad._id;
            await this.applyFilters();
            this.flagLoaded = true;
        }
    }

    async seleccionarTodos(): Promise<void> {
        if (this.flagSolicitudesCargadas) {
            this.flagLoaded = false;
            this.idActividadSeleccionada = this.TODOS_ID;
            await this.applyFilters();
            this.flagLoaded = true;
        }
    }

    toggleOrdenFecha(): void {
        this.ordenFecha = this.ordenFecha === 'asc' ? 'desc' : 'asc';
        this.paginaActual = 1;
        this.recalcularLista();
    }

    async cargarInicialdeSolicitudes(
        sedeParams: { signoSedes: string[] },
        fecha: any
    ): Promise<void> {
        try {
            const allSolicitudes =
                await this.solicitudesService.getAllSolicitudesInscripciones(
                    sedeParams,
                    fecha
                );

            const estadosBandeja = this.estadosChips.map((e) => e.number);

            this.solicitudes = (allSolicitudes || []).filter((solicitud) => {
                const numberState =
                    (solicitud as any)?.lastState_numberState ??
                    solicitud?.lastState?.numberState ??
                    -1;
                return (
                    this.debeIncluirSolicitud(solicitud, numberState) &&
                    estadosBandeja.includes(numberState)
                );
            });

            this.flagSolicitudesCargadas = true;
            this.calculateSolicitudCounts(this.solicitudes);

            // Preservar el trámite seleccionado ("Todos" es válido).
            if (this.actividades?.length) {
                const sigueValida =
                    this.idActividadSeleccionada === this.TODOS_ID ||
                    this.actividades.some(
                        (a) => a._id === this.idActividadSeleccionada
                    );
                if (!sigueValida) {
                    this.idActividadSeleccionada = this.TODOS_ID;
                }
            } else if (this.idActividadSeleccionada !== this.TODOS_ID) {
                console.warn('No hay actividades cargadas para seleccionar.');
                this.idActividadSeleccionada = undefined;
            }

            await this.applyFilters();
        } catch (error) {
            console.error('Error al cargar solicitudes:', error);
            this.flagLoaded = true;
            throw error;
        }
    }

    async applyFilters(): Promise<void> {
        if (this.selectedEstados.length === 0 || this.selectSede.length === 0) {
            this.solicitudesVisibles = [];
            this.paginaActual = 1;
            this.recalcularLista();
            return;
        }

        const filtered = this.solicitudes.filter(
            (s) =>
                this.selectedEstados.includes(s.lastState_numberState) &&
                this.selectSede.includes((s as any).signoSede?._id ?? (s as any).signoSedeId)
        );

        // "Todos" no filtra por trámite.
        this.solicitudesVisibles =
            this.idActividadSeleccionada === this.TODOS_ID
                ? filtered
                : filtered.filter(
                      (s) =>
                          (s as any).actividadId === this.idActividadSeleccionada
                  );
        this.paginaActual = 1;
        this.recalcularLista();
    }

    applyFilter(event: Event): void {
        this.textoFiltro = (event.target as HTMLInputElement).value;
        this.paginaActual = 1;
        this.refrescarBadgesPorFiltro();
        this.recalcularLista();
    }

    recalcularLista(): void {
        const t = this.textoFiltro.trim().toLowerCase();
        const filtradas = t
            ? this.solicitudesVisibles.filter((s) => this.textoCoincide(s, t))
            : this.solicitudesVisibles;

        const ordenadas = [...filtradas].sort((a, b) => {
            const da = a.createdAt ? new Date(a.createdAt).getTime() : 0;
            const db = b.createdAt ? new Date(b.createdAt).getTime() : 0;
            return this.ordenFecha === 'asc' ? da - db : db - da;
        });

        this.solicitudesFiltradas = ordenadas;
        this.totalPaginas = Math.max(1, Math.ceil(ordenadas.length / this.pageSize));
        const inicio = (this.paginaActual - 1) * this.pageSize;
        this.solicitudesPaginadas = ordenadas.slice(inicio, inicio + this.pageSize);
    }

    /** Coincidencia del texto de búsqueda contra los campos visibles. */
    private textoCoincide(s: any, t: string): boolean {
        const haystack = [
            s._nro,
            s.solicitante,
            s.usuario_identificacion,
            s.usuario_email,
            s.signoSedeNombre,
            s.actividad_nombre,
            this.getStateName(s.lastState_numberState),
        ]
            .filter((v) => v != null && v !== '')
            .join(' ')
            .toLowerCase();
        return haystack.includes(t);
    }

    cambiarPagina(pagina: number): void {
        if (pagina < 1 || pagina > this.totalPaginas) {
            return;
        }
        this.paginaActual = pagina;
        this.recalcularLista();
    }

    cambiarPageSize(size: number): void {
        this.pageSize = size;
        this.paginaActual = 1;
        this.recalcularLista();
    }

    // ---- Dropdowns de filtros ----
    abrirDropdown(tipo: 'sede' | 'estado', event: MouseEvent): void {
        if (this.dropdownAbierto === tipo) {
            this.dropdownAbierto = null;
            return;
        }
        const rect = (event.currentTarget as HTMLElement).getBoundingClientRect();
        this.dropdownPos = { top: rect.bottom + 6, left: rect.left };
        this.dropdownAbierto = tipo;
    }

    cerrarDropdown(): void {
        this.dropdownAbierto = null;
    }

    toggleSede(id: string): void {
        if (this.selectSede.includes(id)) {
            this.selectSede = this.selectSede.filter((s) => s !== id);
        } else {
            this.selectSede = [...this.selectSede, id];
        }
        this.applyFilters();
    }

    toggleEstado(number: number): void {
        if (this.selectedEstados.includes(number)) {
            this.selectedEstados = this.selectedEstados.filter((e) => e !== number);
        } else {
            this.selectedEstados = [...this.selectedEstados, number];
        }
        this.applyFilters();
    }

    todasSedesSeleccionadas(): boolean {
        return (
            this.sedesByUsuario.length > 0 &&
            this.sedesByUsuario.every((sede) => this.selectSede.includes(sede._id))
        );
    }

    todasEstadosSeleccionados(): boolean {
        return (
            this.estadosChips.length > 0 &&
            this.estadosChips.every((estado) =>
                this.selectedEstados.includes(estado.number)
            )
        );
    }

    toggleTodoSedes(): void {
        if (this.todasSedesSeleccionadas()) {
            this.selectSede = [];
        } else {
            this.selectSede = this.sedesByUsuario.map((sede) => sede._id);
        }
        this.applyFilters();
    }

    toggleTodoEstados(): void {
        if (this.todasEstadosSeleccionados()) {
            this.selectedEstados = [];
        } else {
            this.selectedEstados = this.estadosChips.map((e) => e.number);
        }
        this.applyFilters();
    }

    // ---- Tooltip ----
    mostrarTooltip(event: MouseEvent, texto: string): void {
        if (this.tooltipTimeout) {
            clearTimeout(this.tooltipTimeout);
            this.tooltipTimeout = null;
        }
        const rect = (event.currentTarget as HTMLElement).getBoundingClientRect();
        this.tooltipTexto = texto;
        this.tooltipPos = { top: rect.bottom + 6, left: rect.left + rect.width / 2 };
        this.tooltipVisible = true;
    }

    ocultarTooltip(): void {
        if (this.tooltipTimeout) {
            clearTimeout(this.tooltipTimeout);
        }
        this.tooltipTimeout = setTimeout(() => {
            this.tooltipVisible = false;
            this.tooltipTimeout = null;
        }, 150);
    }

    @HostListener('document:keydown.escape')
    onEscape(): void {
        this.cerrarDropdown();
    }

    calculateSolicitudCounts(solicitudes: Solicitud[]): void {
        this.cantidadSolicitudesPendientes = 0;
        this.cantidadSolicitudesLeidas = 0;
        this.cantidadSolicitudesTotal = 0;

        // Totales generales (arriba): siempre sobre el set completo.
        const counts = this.contarPorTramite(solicitudes);
        Object.keys(counts.pendientes).forEach((key) => {
            this.cantidadSolicitudesPendientes += counts.pendientes[key];
            this.cantidadSolicitudesTotal += counts.pendientes[key];
        });
        Object.keys(counts.leidas).forEach((key) => {
            this.cantidadSolicitudesLeidas += counts.leidas[key];
            this.cantidadSolicitudesTotal += counts.leidas[key];
        });

        // Badges de la columna de trámites: reflejan el texto filtrado.
        this.refrescarBadgesPorFiltro();
    }

    private contarPorTramite(solicitudes: Solicitud[]): {
        pendientes: { [key: string]: number };
        leidas: { [key: string]: number };
    } {
        const counts: {
            pendientes: { [key: string]: number };
            leidas: { [key: string]: number };
        } = { pendientes: {}, leidas: {} };

        solicitudes.forEach((solicitud) => {
            const nombre = solicitud.actividad_nombre || 'Desconocida';
            if (!counts.pendientes[nombre]) {
                counts.pendientes[nombre] = 0;
            }
            if (!counts.leidas[nombre]) {
                counts.leidas[nombre] = 0;
            }

            const isSedeInUsuario = this.sedesByUsuario.some(
                (sede) =>
                    sede._id ===
                    ((solicitud as any).signoSede?._id ??
                        (solicitud as any).signoSedeId)
            );

            if (!solicitud.leido && isSedeInUsuario) {
                counts.pendientes[nombre]++;
            } else if (solicitud.leido) {
                counts.leidas[nombre]++;
            }
        });

        return counts;
    }

    private refrescarBadgesPorFiltro(): void {
        const t = this.textoFiltro.trim().toLowerCase();
        const base = t
            ? this.solicitudes.filter((s) => this.textoCoincide(s, t))
            : this.solicitudes;
        this.solicitudCounts = this.contarPorTramite(base);
    }

    getCountLeidas(actividad: Actividad): number {
        return this.solicitudCounts.leidas[actividad.nombre] || 0;
    }

    getCountPendientes(actividad: Actividad): number {
        return this.solicitudCounts.pendientes[actividad.nombre] || 0;
    }

    /** Suma de "sin leer" de todos los trámites (badge del sintético "Todos"). */
    getTotalPendientes(): number {
        return Object.keys(this.solicitudCounts.pendientes).reduce(
            (acc, key) => acc + this.solicitudCounts.pendientes[key],
            0
        );
    }

    /** Suma de "leídas" de todos los trámites (badge del sintético "Todos"). */
    getTotalLeidas(): number {
        return Object.keys(this.solicitudCounts.leidas).reduce(
            (acc, key) => acc + this.solicitudCounts.leidas[key],
            0
        );
    }

    getStateName(stateNumber: number): string {
        const estado = this.iAppOfertas.selectEstados.find(
            (e) => e.number === stateNumber
        );
        return estado ? estado.name : 'Desconocido';
    }

    getEstadoChipClase(stateNumber: number): string {
        switch (stateNumber) {
            case 16:
                return 'estado--aprobado'; // aprobada (verde)
            case 15:
                return 'estado--revision'; // con DDJJ (amarillo)
            case 14:
                return 'estado--neutro'; // parcial, sin DDJJ (gris)
            case 5:
                return 'estado--anulado'; // anulada (rojo)
            default:
                return 'estado--neutro';
        }
    }

    private debeIncluirSolicitud(solicitud: any, numberState: number): boolean {
        const createdAt = solicitud?.createdAt ? new Date(solicitud.createdAt) : null;
        if (createdAt && createdAt >= this.FECHA_CORTE_FILTRO) {
            return numberState !== 0;
        }
        return numberState !== 0 && numberState !== 1;
    }

    trackBySolicitud(index: number, s: any): string {
        return s._id;
    }

    openDialogModalSolicitud(): void {
        const dialogRef = this.dialog.open(BandejaInscripcionesComponent, {
            width: '100vw',
            height: '100vh',
            maxWidth: '100vw',
            maxHeight: '100vh',
            panelClass: ['full-screen-dialog', 'ds-dialog'],
            disableClose: true,
        });
        dialogRef.afterClosed().subscribe();
    }

    async verSolicitud(solicitud: Solicitud): Promise<void> {
        this.loading = true;
        try {
            const sol = await this.solicitudesService.getSolicitudById(solicitud._id);
            this.solicitudesService.setSolicitudSeleccionada(sol);
            await this.updateSolicitudLeido(sol);
            solicitud.leido = true;
            this.openDialogModalSolicitud();
        } catch (error) {
            console.error('Error al ver la solicitud:', error);
        } finally {
            this.loading = false;
        }
    }

    async updateSolicitudLeido(sol: Solicitud): Promise<void> {
        const solicitud: any = {
            _id: sol._id,
            leido: true,
            titular: sol.titular,
            usuario: sol.usuario,
            pais: sol.pais._id,
            actividad: sol.actividad._id,
        };
        await this.solicitudesService.updateSolicitudLeido(sol._id, solicitud);
    }

    async exportarSolicitudes(): Promise<void> {
        if (!this.fechaDesdeStr || !this.fechaHastaStr) {
            this.snackBar.open(
                'Por favor, seleccione ambas fechas para exportar',
                'Cerrar',
                { duration: 3000 }
            );
            return;
        }

        this.loading = true;

        try {
            const fechaParams = {
                fechaDesde: this.fechaDesdeStr,
                fechaHasta: this.fechaHastaStr,
            };
            const sedesParams: any = { signoSedes: this.selectSede };

            const allSolicitudes =
                await this.solicitudesService.getSolicitudesBySedeExtendido(
                    sedesParams,
                    fechaParams
                );

            const filtradas = (allSolicitudes as any[]).filter((solicitud) => {
                const numberState = solicitud?.lastState_numberState ?? -1;
                return this.debeIncluirSolicitud(solicitud, numberState);
            });

            if (!filtradas || filtradas.length === 0) {
                this.snackBar.open(
                    'No hay solicitudes para exportar en el rango de fechas seleccionado',
                    'Cerrar',
                    { duration: 3000 }
                );
                return;
            }

            this.generarExcel(this.prepararDatosParaExcel(filtradas));
            this.snackBar.open(
                `Exportadas ${filtradas.length} solicitudes`,
                'Cerrar',
                { duration: 3000 }
            );
        } catch (error) {
            console.error('Error al exportar solicitudes:', error);
            this.snackBar.open('Error al exportar las solicitudes', 'Cerrar', {
                duration: 3000,
            });
        } finally {
            this.loading = false;
        }
    }

    prepararDatosParaExcel(solicitudes: any[]): any[] {
        return solicitudes.map((solicitud) => ({
            'Número de Solicitud': solicitud._nro,
            DNI: solicitud.usuario_identificacion || 'N/A',
            Paciente: solicitud.beneficiario || 'N/A',
            Fecha: this.formatearFechaExcel(solicitud.createdAt),
            Procedimiento: solicitud.actividad_nombre || 'N/A',
            Solicitante: solicitud.solicitante || 'N/A',
            Sede: solicitud.signoSedeNombre || 'N/A',
            Administrador: solicitud.lastState_userName || 'N/A',
            Estado: `${solicitud.lastState_state}`,
            Observaciones: solicitud.lastState_observaciones || 'N/A',
            'Estados Historicos': solicitud.historicoEstados || 'N/A',
            'Fecha del Ultimo Estado': this.formatearFechaExcel(solicitud.dateLastState),
        }));
    }

    formatearFechaExcel(fechaISO: string | Date): string {
        try {
            const fechaString =
                typeof fechaISO === 'string'
                    ? fechaISO
                    : fechaISO instanceof Date
                    ? fechaISO.toISOString()
                    : '';
            const fecha = new Date(fechaString);
            const dia = fecha.getDate().toString().padStart(2, '0');
            const mes = (fecha.getMonth() + 1).toString().padStart(2, '0');
            const anio = fecha.getFullYear();
            const horas = fecha.getHours().toString().padStart(2, '0');
            const minutos = fecha.getMinutes().toString().padStart(2, '0');
            return `${dia}/${mes}/${anio} ${horas}:${minutos}`;
        } catch (error) {
            console.error('Error formateando fecha:', error);
            return 'Fecha inválida';
        }
    }

    generarExcel(datos: any[]): void {
        const worksheet = XLSX.utils.json_to_sheet(datos);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Solicitudes');

        const wscols = [
            { wch: 20 }, { wch: 12 }, { wch: 25 }, { wch: 20 }, { wch: 35 },
            { wch: 30 }, { wch: 20 }, { wch: 30 }, { wch: 18 }, { wch: 50 },
            { wch: 50 }, { wch: 20 },
        ];
        worksheet['!cols'] = wscols;

        const nombreArchivo = `Inscripciones_${this.fechaDesdeStr}_a_${this.fechaHastaStr}.xlsx`;
        XLSX.writeFile(workbook, nombreArchivo, { compression: true });
    }
}
